const i=e=>{const[t,s]=e.split(" ");return s?`${t[0]}${s[0]}`:t.slice(0,2)};export{i as getInitials};
